<template>
    <div class="ai-analyst">
        <!-- AI 图标 -->
        <div class="ai-analyst__icon">
            <img src="../../assets/images/ai_analyst_icon.png" alt="AI Analyst" />
        </div>

        <!-- 内容区域 -->
        <div class="ai-analyst__content">
            <h5 class="ai-analyst__title">{{ title }}</h5>
            <p class="ai-analyst__summary">{{ summary }}</p>
        </div>

        <!-- 箭头 -->
        <div class="ai-analyst__arrow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 4L10 8L6 12"
                    stroke="#999"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: 'AI'
  },
  summary: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {};
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.ai-analyst {
    display: flex;
    align-items: center;

    width: 100%;
    height: 1.15rem;
    padding: 0 0.2rem;
    border-radius: 0.16rem;
    cursor: pointer;
    transition: background 0.2s ease;

    // 背景图
    background-image: url('../../assets/images/ai_analyst_bg.png');
    background-size: 100% 100%;

    &:hover {
        background: #f0f0f0;
    }

    &__icon {
        flex-shrink: 0;
        width: auto;
        height: 0.87rem;

        img {
            width: auto;
            height: 100%;
        }
    }

    &__content {
        flex: 1;
        min-width: 0;
        height: 0.87rem;
        display: flex;
        flex-direction: column;
        justify-content: center;

        padding-left: 0.05rem;
    }

    &__title {
        font-size: 0.28rem;
        font-weight: 600;
        color: #262626;
        line-height: 0.37rem;
    }

    &__summary {
        font-size: 0.24rem;
        color: #262626;
        line-height: 0.32rem;
        letter-spacing: -0.01rem;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }

    &__arrow {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.32rem;
        height: 0.32rem;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
